import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import {bindActionCreators} from 'redux';
import Button from '@s/Button';
import { deleteReservation } from 'checkout/actions/reservation';
import { triggerTransition } from '@uirouter/redux';
import { setCheckoutOverlay, setCancelConfirm } from '../../../actions/ui';
import { backToDefaultLocale } from "../../../actions/intl";
import Translation from "../../../../shared/Translation";

class CancelConfirmation extends Component {

    render() {
        return(
            <div className="kiosk__modal">
                <div className="kiosk__modal__content">
                    <div className="kiosk__modal__title">
                      <Translation>{'checkout__kiosk_cancel_confirm'}</Translation>
                    </div>
                    <Button
                        className="kiosk-modal__button kiosk-modal__button--primary"
                        onClick={ this.onOrderVoid }
                    ><Translation>{'checkout__yes'}</Translation></Button>
                    <Button
                        className="kiosk-modal__button kiosk-modal__button--secondary"
                        onClick={ this.onCancel }
                    ><Translation>{'checkout__no'}</Translation></Button>
                </div>
            </div>
        )
    }

    onCancel = () => {
        this.props.setCancelConfirm(false);
    }

    onOrderVoid = async () => {
        this.props.setCancelConfirm(false);
        this.props.setCheckoutOverlay(false);
        this.props.deleteReservation();
        this.props.backToDefaultLocale();
        //goal here is to navigate to the root /
        this.props.triggerTransition('ticketPicker');
    }
}

const mapStateToProps = state => {
    return {
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        deleteReservation,
        triggerTransition,
        setCheckoutOverlay,
        setCancelConfirm,
        backToDefaultLocale
    }, dispatch);
}

CancelConfirmation.propTypes = {
}

export default connect(mapStateToProps, mapDispatchToProps)(CancelConfirmation);
